import React from 'react';
import './ToggleSwitch.css';

const ToggleSwitch = ({
  isOn,
  onToggle,
  disabled = false,
  size = 'medium',
  onColor = '#28a745',
  offColor = '#dc3545',
  className = '',
  ...props
}) => {
  const handleClick = () => {
    if (!disabled && onToggle) {
      onToggle();
    }
  };

  const switchClasses = [
    'toggle-switch',
    `toggle-switch-${size}`,
    isOn ? 'toggle-switch-on' : 'toggle-switch-off',
    disabled ? 'toggle-switch-disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const switchStyle = {
    backgroundColor: disabled ? '#ccc' : isOn ? onColor : offColor,
  };

  return (
    <div className={switchClasses} onClick={handleClick} style={switchStyle} {...props}>
      <div className="toggle-switch-handle">
        <div className="toggle-switch-text">{isOn ? 'ON' : 'OFF'}</div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
